import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useSetPledgeShopCharityMutation = createMutationHook(
  CreatorIntegrationsApiClient.setPledgeShopCharity,
  {
    mutationKey: ['setPledgeShopCharity'],
  },
)
